<template>
  <header
    id="header"
    class="sticky top-0 z-10 transition-all duration-200"
    :class="{
      '-translate-y-full':
        isHeaderHidden &&
        !isSearchBarActive &&
        !isSidebarOpened &&
        !isMenuActive,
    }"
  >
    <div class="flex w-full">
      <div
        ref="header"
        class="bg-static-default-low border-static-default-low relative z-[1] w-full border-b-1 transition-all duration-200"
      >
        <Banner class="relative z-[2] hidden md:flex" />
        <Main />
        <NavMenu class="hidden md:block" />
      </div>
    </div>
    <NavBurgerMenu v-if="isSidebarOpened" />
    <ClientOnly>
      <CountrySwitchRedirection
        v-if="hasCountrySwitchRedirection"
        ref="countrySwitchBannerRef"
      />
    </ClientOnly>
  </header>
</template>

<script setup lang="ts">
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import { useToggleSearchBar } from '~/scopes/search-bar/composables/useToggleSearchBar'

import { useHideOnScroll } from '../../composables/useHideOnScroll'
import { useNavigation } from '../../composables/useNavigation'
import CountrySwitchRedirection from '../CountrySwitch/CountrySwitchRedirection.vue'
import NavBurgerMenu from '../NavBurgerMenu/NavBurgerMenu.vue'
import NavMenu from '../NavMenu/NavMenu.vue'

import Banner from './components/Banner.vue'
import Main from './components/Main.vue'
import { useHeader } from './composables/useHeader'

const { hidden: isHeaderHidden } = useHideOnScroll()
const { isOpen: isSidebarOpened, isMenuActive } = useNavigation()
const { isSearchBarActive } = useToggleSearchBar()
const experiments = useExperiments()

const hasCountrySwitchRedirection =
  experiments['experiment.countrySwitchRedirection'] === 'withRedirection'

useHeader()
</script>
